<template>
  <div
    class="DocumentsElement"
    :class="{ 'is-accepted': document.is_accepted || isLoading }"
  >
    <div class="DocumentsElement__header">
      {{ document.is_accepted ? 'Potwierdzono' : 'Do potwierdzenia!' }}
    </div>
    <div class="DocumentsElement__body" v-loading="isLoading">
      <div class="DocumentsElement__row file-title">
        <div class="DocumentsElement__row__title">Nazwa pliku:</div>
        <el-tooltip
          v-if="document.file_name.length > 50"
          class="box-item"
          effect="dark"
          :content="document.file_name"
          placement="top"
        >
          <p class="DocumentsElement__row__content">{{ document.file_name }}</p>
        </el-tooltip>
        <p v-else class="DocumentsElement__row__content">
          {{ document.file_name }}
        </p>
      </div>
      <div class="DocumentsElement__row">
        <div class="DocumentsElement__row__title">Utworzono:</div>
        <div class="DocumentsElement__row__content">
          {{ document.created_at.substr(0, 16) }}
        </div>
      </div>
      <div class="DocumentsElement__row">
        <div class="DocumentsElement__row__time-left">
          <img
            class="DocumentsElement__icon"
            src="@/assets/images/black-clock.svg"
            style="margin-right: 0.25rem"
          />
          <div
            class="DocumentsElement__row__time-left__text"
            style="margin-right: 0.25rem"
          >
            Czas do wygaśnięcia:
          </div>
          <div
            class="DocumentsElement__row__time-left__text"
            style="font-weight: 600"
          >
            {{ timeToExpired }} dni
          </div>
        </div>
      </div>
      <div class="DocumentsElement__row">
        <el-checkbox
          size="large"
          v-model="acceptContract"
          :disabled="document.is_accepted"
          class="DocumentsElement__checkbox"
        >
          <p style="font-size: 0.75rem !important; font-weight: 600">
            Akceptuję warunki przekazane<br /> w dokumentacji nr: {{ document.issue_key }}
          </p>
        </el-checkbox>
      </div>
      <div class="DocumentsElement__row">
        <button
          class="DocumentsElement__confirm-button"
          :class="{
            'DocumentsElement__confirm-button--green':document.is_downloaded,
            'DocumentsElement__confirm-button-confirmed': document.is_accepted
          }"
          @click="handleAcceptContract"
          :disabled="!acceptContract || document.is_accepted"
        >
          {{ document.is_accepted ? 'Potwierdzono' : 'Potwierdź' }}
        </button>
      </div>
      <div class="DocumentsElement__row">
        <button
          class="DocumentsElement__download-button"
          :style="animationStyleProperty"
          @click="downloadFile(document.issue_key)">
          Pobierz dokument
        </button>
      </div>
    </div>
  </div>
</template>

<script src="./component.js"></script>
<style src="./style.sass" lang="sass"></style>
